import { render, staticRenderFns } from "./AuditoriaMolexEventosDetalle.vue?vue&type=template&id=232670c7"
import script from "./AuditoriaMolexEventosDetalle.vue?vue&type=script&lang=js"
export * from "./AuditoriaMolexEventosDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports